<template>
  <div class="taskwork-chat-container">
    <div class="taskwork-chat-window">
      <div v-for="(msg, idx) in messages" :key="idx" :class="['chatmsg', msg.role]">
        <template v-if="msg.role === 'assistant'">
          <div style="display:flex;align-items:flex-start;margin-bottom:8px;">
            <div style="width:30px;height:30px;display:inline-block;vertical-align:middle;text-align:center;padding:2px;margin-right:10px;">
              <img style="transform: rotateY(0deg) rotate(135deg);border-radius:50%;width:26px;height:26px;" :src="require('@/assets/foclarity-icon.png')" alt="Foclarity AI" />
            </div>
            <div style="display:inline-block;vertical-align:middle;">
              <strong>Foclarity.AI</strong>
              <div style="padding-top:2px;">
                <span v-html="renderMarkdown(msg.content)"></span>
              </div>
              <div v-if="msg.created_at" class="msg-meta">{{ formatDate(msg.created_at) }}</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div style="display:flex;align-items:flex-start;margin-bottom:8px;text-align:left;">
            <div v-if="user && user.profile_image" :style="'border-radius:50%;width:30px;height:30px;background:url(https://corl8-files.s3.amazonaws.com/' + user.profile_image +') no-repeat;background-size:cover;display:inline-block;vertical-align:middle;margin-right:8px;'"></div>
            <div v-else style="border-radius:50%;width:30px;height:30px;display:inline-block;vertical-align:middle;margin-right:10px;" >
              <img style="width:30px;height:30px;" :src="require('@/assets/ic_person.png')" alt="profile icon" />
            </div>
            <div style="display:inline-block;vertical-align:middle;text-align:left;">
              <strong>{{ user && user.first_name ? user.first_name : 'You' }}</strong>
              <div style="padding-top:2px;">
                {{ msg.content }}
              </div>
              <div v-if="msg.created_at" class="msg-meta">{{ formatDate(msg.created_at) }}</div>
            </div>
          </div>
        </template>
      </div>
      <div v-if="loading">AI is typing...</div>
    </div>
    <div class="taskwork-input">
      <input v-model="inputMessage" @keyup.enter="sendMessage" placeholder="Type your question or command..." />
      <button @click="sendMessage" :disabled="!inputMessage || loading">Send</button>
    </div>
    <div v-if="lastChatwork && Array.isArray(lastChatwork) && lastChatwork.length > 2 && !showFullHistory" style="text-align:center;margin-top:8px;">
      <a href="#" @click.prevent="loadFullHistory" style="font-size:0.95em;color:#0077cc;text-decoration:underline;cursor:pointer;">Load chat history</a>
    </div>
  </div>
</template>

<script>
import { taskService } from '../../_services';
import { userService } from '../../_services/user.service';
import marked from 'marked';

// Configure marked to open links in a new tab
const renderer = new marked.Renderer();
renderer.link = function(href, title, text) {
  return `<a href="${href}"${title ? ` title="${title}"` : ''} target="_blank" rel="noopener noreferrer">${text}</a>`;
};
marked.setOptions({ renderer });

export default {
  props: ['task', 'scid', 'cid', 'mid'],
  data() {
    return {
      user: null,
      messages: [
        { role: 'assistant', content: 'Welcome back, let me catch you up...' }
      ],
      inputMessage: '',
      loading: false,
      lastChatwork: null,
      showFullHistory: false
    };
  },
  created() {
    userService.getMe().then(data => {
      this.user = data;
    });
  },
  mounted() {
    this.scrollToBottom();
    // Send initial message if task is provided
    if (this.task && this.task.task_description) {
      this.sendMessage(`Catch me up.`);
    }
  },
  updated() {
    this.scrollToBottom();
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        const chatWindow = this.$el.querySelector('.taskwork-chat-window');
        if (chatWindow) {
          chatWindow.scrollTop = chatWindow.scrollHeight;
        }
      });
    },
    renderMarkdown(content) {
      return marked(content || '');
    },
    async sendMessage(messageOverride) {
      let messageToSend = '';
      if (typeof messageOverride === 'string') {
        messageToSend = messageOverride;
      } else {
        messageToSend = this.inputMessage;
      }
      if (!messageToSend) return;
      const userMsg = { role: 'user', content: messageToSend };
      this.messages.push(userMsg);
      this.loading = true;
      try {
        const res = await taskService.taskWorkChat(
          this.scid,
          this.cid,
          this.mid,
          this.task.task_id,
          messageToSend
        );
        this.lastChatwork = res.chatwork;
        this.showFullHistory = false;
        let newMessages = [userMsg];
        let lastAI = null;
        let lastAICreated = null;
        if (Array.isArray(res.chatwork)) {
          for (let i = res.chatwork.length - 1; i >= 0; i--) {
            const msgObj = res.chatwork[i];
            if (msgObj.role === 'assistant' && msgObj.message) {
              lastAI = msgObj.message;
              lastAICreated = msgObj.created_at || null;
              break;
            }
          }
        } else if (res.chatwork && res.chatwork.message) {
          lastAI = res.chatwork.message;
          lastAICreated = res.chatwork.created_at || null;
        }
        if (lastAI) {
          newMessages.push({ role: 'assistant', content: lastAI, created_at: lastAICreated });
        } else {
          newMessages.push({ role: 'assistant', content: '[No response from AI]' });
        }
        this.messages = newMessages;
      } catch (e) {
        this.messages = [
          userMsg,
          { role: 'assistant', content: 'Error: ' + e }
        ];
      }
      this.inputMessage = '';
      this.loading = false;
      this.scrollToBottom();
    },
    loadFullHistory() {
      if (Array.isArray(this.lastChatwork)) {
        this.messages = this.lastChatwork
          .filter(msgObj => msgObj.role && msgObj.message)
          .map(msgObj => ({
            role: msgObj.role || 'assistant',
            content: msgObj.message,
            created_at: msgObj.created_at || null
          }));
        this.showFullHistory = true;
        this.scrollToBottom();
      }
    },
    handleExampleClick(prompt) {
      this.sendMessage(prompt);
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
    },
  },
};
</script>

<style scoped>
/* Responsive, full-page chat view styles for TaskWork */
.taskwork-chat-container {
  display: block;
  background: #f9f9f9;
  margin: 0;
  padding: 0;
}
.taskwork-chat-window {
  /* Remove flex and overflow to allow natural page growth */
  background: #f9f9f9;
  padding: 16px 0 0 0;
  margin: 0 auto;
  max-width: 700px;
  width: 100%;
}
.chatmsg {
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
}
.chatmsg.assistant {
  justify-content: flex-start;
}
.chatmsg .profile-img,
.chatmsg .ai-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 12px;
  background-size: cover;
  background-position: center;
}
.chatmsg .ai-img img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: block;
}
.chatmsg .msg-content {
  display: inline-block;
  max-width: 80vw;
  background: #fff;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 1rem;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  word-break: break-word;
}
.taskwork-input {
  display: flex;
  gap: 8px;
  padding: 16px 0 16px 0;
  background: #f9f9f9;
  border-top: 1px solid #eee;
  max-width: 700px;
  margin: 0 auto;
  width: 100%;
}
input {
  flex: 1;
  padding: 14px;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #fff;
}
button {
  padding: 14px 24px;
  font-size: 1rem;
  border-radius: 6px;
  border: none;
  background: #0077cc;
  color: #fff;
  cursor: pointer;
}
.user {
  text-align: right;
  color: #0077cc;
}
.assistant {
  text-align: left;
  color: #111;
}
.msg-meta {
  font-size: 0.85em;
  color: #888;
  margin-top: 2px;
}
@media (max-width: 900px) {
  .taskwork-chat-window, .taskwork-input {
    padding-left: 8px;
    padding-right: 8px;
  }
}
@media (max-width: 600px) {
  .taskwork-chat-container {
    padding: 0;
  }
  .taskwork-chat-window {
    padding: 4px 0 0 0;
    font-size: 0.98rem;
  }
  .chatmsg .msg-content {
    font-size: 0.98rem;
    padding: 10px 12px;
    max-width: 95vw;
  }
  .taskwork-input {
    padding: 8px 0 8px 0;
    gap: 4px;
  }
  input, button {
    font-size: 1rem;
    padding: 10px;
  }
}
</style>
